import { TabGroup } from '@sanlam-glacier/app-common/components';
import DocumentsRequired from '../../molecules/documents-required/DocumentsRequired';
import DocumentsRequiredLabel from '../../atoms/documents-required-label/DocumentsRequiredLabel';
import { InstructionTabProps } from 'modules/case-tracking/types/documents-required/documents-required.types';
import { ActivityHistory } from '../../molecules/activity-history/ActivityHistory';

const InstructionTab = ({ caseDetails, handleTabChange, ...props }: InstructionTabProps) => {
  return (
    <TabGroup
      onChange={(tabName) => {
        if (!handleTabChange) return;
        if (tabName === 'activityHistory') {
          handleTabChange(true);
        } else {
          handleTabChange(false);
        }
      }}
      tabs={[
        {
          content: <ActivityHistory activityHistory={caseDetails?.activityHistory} />,
          label: 'Activity history',
          name: 'activityHistory',
          showOverflow: true
        },
        {
          content: <DocumentsRequired {...props} />,
          label: <DocumentsRequiredLabel {...props} />,
          name: 'documentsRequired',
          showOverflow: true
        }
      ]}
    />
  );
};

export default InstructionTab;
